import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import analyticsHero from "../assets/Hero/analytics-hero.webp"; // Replace with your hero image
import analyticsImage from "../assets/Hero/analytics.png"; // Replace with your analytics image
import "../assets/css/analyticsAndReportingPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const analyticsData = {
  hero: {
    title: "Analytics & Reporting",
    subtitle: "Unlock Insights and Drive Decisions with Advanced Analytics",
  },
  introduction: {
    heading: "Why Analytics & Reporting Matter",
    paragraphs: [
      "Analytics and reporting provide actionable insights into your business operations, enabling data-driven decision-making and improved performance.",
      "Our analytics solutions are designed to deliver accurate, real-time data visualization and reporting for businesses of all sizes.",
    ],
  },
  cta: {
    heading: "Ready to Transform Your Data into Insights?",
    text: "Contact us today to learn more about our Analytics & Reporting Solutions and how we can help your business thrive.",
  },
};

export const AnalyticsAndReportingPage = ({ data }) => {
  const analyticsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = analyticsRef.current.querySelectorAll(".analytics-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: analyticsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="analytics-page" ref={analyticsRef}>
      {/* Hero Section */}
      <div
        className="analytics-hero-section"
        style={{ backgroundImage: `url(${analyticsHero})` }}
      >
        <h1 className="analytics-animate">{analyticsData.hero.title}</h1>
        <p className="analytics-animate">{analyticsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container analytics-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="analytics-animate">{analyticsData.introduction.heading}</h2>
            {analyticsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="analytics-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 analytics-image-container">
            <img
              src={analyticsImage}
              className="img-fluid analytics-animate"
              alt="Analytics & Reporting"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container analytics-cta">
        <h2 className="analytics-animate">{analyticsData.cta.heading}</h2>
        <p className="analytics-animate">{analyticsData.cta.text}</p>
        <button
          className="btn btn-primary analytics-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};